import React, { useState } from "react";
import axios from "axios";
import microphoneImg from "../images/microphone.png";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://4fkqq7adx3.execute-api.us-east-1.amazonaws.com/prod/contact-us",
        form,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.status === "success") {
        alert("Message Sent.");
      } else {
        alert("Message failed to send.");
      }
    } catch {
      // Still show success UI
    }
    setSubmitted(true);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section id="contact" className="max-w-screen-xl mx-auto py-20 md:py-24 px-6">
      <div className="flex flex-col md:flex-row justify-between gap-12">
        {/* Image */}
        <div className="md:w-5/12 flex-shrink-0 h-80 md:h-auto">
          <div
            className="w-full h-full min-h-[300px] rounded bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url(${microphoneImg})` }}
          />
        </div>

        {/* Form */}
        <div className="md:w-7/12 lg:py-8 text-center md:text-left">
          <p className="text-primary-500 font-bold text-sm uppercase tracking-widest">Contact Us</p>
          <h2 className="mt-4 font-black text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Any questions? <span className="text-primary-500">Get in touch</span> with us.
          </h2>
          <p className="mt-4 text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100">
            Email us at contact@metabetta.com, or fill in the form below and we'll be in touch promptly.
          </p>

          {submitted ? (
            <div className="mt-8 text-primary-500 text-xl font-bold">Thank you!</div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-8 md:mt-10 flex flex-col max-w-sm mx-auto md:mx-0">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={form.name}
                onChange={handleChange}
                required
                className="border-b-2 border-gray-300 py-3 focus:outline-none font-medium transition focus:border-primary-500"
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email Address"
                value={form.email}
                onChange={handleChange}
                required
                className="mt-6 border-b-2 border-gray-300 py-3 focus:outline-none font-medium transition focus:border-primary-500"
              />
              <textarea
                name="message"
                placeholder="Your Message Here"
                rows={4}
                value={form.message}
                onChange={handleChange}
                required
                className="mt-6 border-b-2 border-gray-300 py-3 focus:outline-none font-medium transition focus:border-primary-500 resize-none"
              />
              <button
                type="submit"
                className="mt-8 px-8 py-3 bg-primary-500 text-white font-bold rounded hover:bg-primary-700 transition self-start"
              >
                Submit
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
